import browser from "webextension-polyfill";
import { ytHavenFeedbackMenuOpen, ytHavenIframeShown, ytHavenInfoBoxShown, ytHavenNextVideoNotFound, ytHavenToggleStateUpdate, } from "../shared/index.js";
import { resumeCurrentVideo, startPause, stopPause } from "./pause-video.js";
import { createIframePlayer, createLogoSVG, getIframePlayer, getToggleState, isDarkMode, isInHavenExperiment, recordEvent, videoContextStore, } from "./shared.js";
import { menuIcon } from "../img/menu.js";
import { checkIcon } from "../img/check.js";
import { crossIcon } from "../img/cross.js";
var PlayerState;
(function (PlayerState) {
    PlayerState[PlayerState["ENDED"] = 0] = "ENDED";
})(PlayerState || (PlayerState = {}));
const infoBoxId = "yt-haven-info-box";
const SURVEY_URL = "https://survey.alchemer.eu/s3/90847063/Quick-Feedback";
async function handleEmbeddedVideoEnding() {
    const { nextVideoId, autoplayEnabled, playlistId } = videoContextStore.getVideoContext();
    if (!autoplayEnabled && !playlistId) {
        return;
    }
    const nextVideoAnchor = document.querySelector("#movie_player > div.ytp-chrome-bottom > div.ytp-chrome-controls > div.ytp-left-controls > a.ytp-next-button.ytp-button");
    if (nextVideoAnchor &&
        nextVideoAnchor instanceof HTMLAnchorElement &&
        nextVideoAnchor.href) {
        nextVideoAnchor.click();
        return;
    }
    const searchParams = new URLSearchParams(window.location.search);
    if (nextVideoId) {
        searchParams.set("v", nextVideoId);
        window.location.search = searchParams.toString();
        return;
    }
    removeEmbedPlayer();
    resumeCurrentVideo();
    void browser.runtime.sendMessage({
        type: ytHavenNextVideoNotFound,
    });
}
const iFrameMessageListener = (event) => {
    var _a;
    const playerElem = getIframePlayer();
    if (playerElem &&
        playerElem instanceof HTMLIFrameElement &&
        event.source === playerElem.contentWindow &&
        "data" in event &&
        typeof event.data === "string") {
        const eventData = JSON.parse(event.data);
        const playerState = (_a = eventData === null || eventData === void 0 ? void 0 : eventData.info) === null || _a === void 0 ? void 0 : _a.playerState;
        if (playerState === PlayerState.ENDED) {
            void handleEmbeddedVideoEnding();
        }
    }
};
export async function addEmbedVideoOnTop(targetElement) {
    var _a;
    const { videoId, startSeconds } = videoContextStore.getVideoContext();
    let playerElem = getIframePlayer();
    if (!(playerElem instanceof HTMLIFrameElement)) {
        removeEmbedPlayer();
    }
    void recordEvent(ytHavenIframeShown);
    if (playerElem && playerElem instanceof HTMLIFrameElement) {
        (_a = playerElem.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify({
            event: "command",
            func: "loadVideoById",
            args: [videoId, startSeconds],
        }), "*");
        return;
    }
    playerElem = createIframePlayer({
        videoId,
        startSeconds,
    });
    window.addEventListener("message", (event) => {
        iFrameMessageListener(event);
    });
    targetElement.style.position = "relative";
    targetElement.style.overflow = "hidden";
    targetElement.appendChild(playerElem);
}
function createToggleSwitch(initialState = false, onToggle = async () => { }) {
    let isActive = initialState;
    const colors = {
        ENABLED: "#3c5b81",
        DISABLED: isDarkMode() ? "rgba(255, 255, 255, 0.15)" : "#b0c0d1",
    };
    const toggle = document.createElement("div");
    Object.assign(toggle.style, {
        width: "36px",
        height: "18px",
        backgroundColor: initialState ? colors.ENABLED : colors.DISABLED,
        borderRadius: "18px",
        position: "relative",
        cursor: "pointer",
        transition: "background-color 0.3s ease",
        display: "inline-block",
        flex: "none",
    });
    const thumb = document.createElement("div");
    Object.assign(thumb.style, {
        width: "18px",
        height: "18px",
        backgroundColor: "#ffffff",
        color: "#666",
        borderRadius: "50%",
        position: "absolute",
        top: "0px",
        left: initialState ? "18px" : "0px",
        boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
        transition: "left 0.3s ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    });
    thumb.innerHTML = isActive ? checkIcon : crossIcon;
    toggle.appendChild(thumb);
    toggle.addEventListener("click", () => {
        const newState = !isActive;
        if (newState !== isActive) {
            isActive = newState;
            toggle.style.backgroundColor = isActive
                ? colors.ENABLED
                : colors.DISABLED;
            thumb.style.left = isActive ? "18px" : "0px";
            thumb.innerHTML = isActive ? checkIcon : crossIcon;
            void onToggle(isActive);
        }
    });
    return toggle;
}
function createMenuComponent() {
    const container = document.createElement("div");
    Object.assign(container.style, {
        position: "relative",
        display: "inline-block",
    });
    const menuButton = document.createElement("div");
    menuButton.innerHTML = menuIcon;
    Object.assign(menuButton.style, {
        cursor: "pointer",
        width: "24px",
        textAlign: "center",
        fontSize: "24px",
    });
    const menu = document.createElement("div");
    Object.assign(menu.style, {
        display: "none",
        position: "absolute",
        top: "0",
        right: "0",
        transform: "translateY(-100%)",
        background: isDarkMode() ? "#222" : "#FFF",
        borderRadius: "12px",
        padding: "8px 0",
        boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
        width: "256px",
        color: isDarkMode() ? "#FFF" : "#000",
        fontSize: "14px",
        zIndex: "1000",
    });
    const createItem = (emoji, i18nKey, href = "") => {
        const item = document.createElement("div");
        item.textContent = `${emoji} ${browser.i18n.getMessage(i18nKey)}`;
        Object.assign(item.style, {
            padding: "10px 16px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            cursor: "pointer",
        });
        item.addEventListener("mouseenter", () => {
            item.style.backgroundColor = isDarkMode()
                ? "rgba(255, 255, 255, 0.15)"
                : "rgba(0, 0, 0, 0.15)";
        });
        item.addEventListener("mouseleave", () => {
            item.style.backgroundColor = "";
        });
        item.addEventListener("click", () => {
            menu.style.display = "none";
            void recordEvent(i18nKey);
            if (href) {
                window.open(href, "_blank");
            }
        });
        return item;
    };
    menu.appendChild(createItem("😍", "yt_haven_feedback_love"));
    menu.appendChild(createItem("🥲", "yt_haven_feedback_fix_it", SURVEY_URL));
    menu.appendChild(createItem("👎", "yt_haven_feedback_hate", SURVEY_URL));
    menuButton.addEventListener("click", () => {
        menu.style.display = menu.style.display === "block" ? "none" : "block";
        if (menu.style.display === "block") {
            void recordEvent(ytHavenFeedbackMenuOpen);
        }
    });
    window.addEventListener("click", (e) => {
        if (!container.contains(e.target)) {
            menu.style.display = "none";
        }
    });
    container.appendChild(menuButton);
    container.appendChild(menu);
    return container;
}
function addInfoBox(targetContainer, toggleState, onToggle) {
    removeInfoBox();
    const infoBoxElem = document.createElement("div");
    infoBoxElem.id = infoBoxId;
    Object.assign(infoBoxElem.style, {
        marginTop: "12px",
        backgroundColor: isDarkMode() ? "#272727" : "#dff1fe",
        borderRadius: "12px",
        padding: "12px",
        fontSize: "14px",
        color: isDarkMode() ? "#fff" : "#000",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "36px",
    });
    const logoElem = createLogoSVG();
    Object.assign(logoElem.style, {
        height: "20px",
        display: "block",
        marginBottom: "4px",
    });
    const actionContainer = document.createElement("div");
    Object.assign(actionContainer.style, {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        flex: "none",
        borderLeft: `1px solid ${isDarkMode() ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.15)"}`,
        paddingLeft: "18px",
    });
    const toggleContainer = document.createElement("div");
    Object.assign(toggleContainer.style, {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        gap: "6px",
        paddingTop: "12px",
    });
    const toggleElem = createToggleSwitch(toggleState, onToggle);
    toggleContainer.appendChild(toggleElem);
    const toggleLabel = document.createElement("div");
    Object.assign(toggleLabel.style, {
        textAlign: "center",
        fontSize: "12px",
        opacity: "0.5",
    });
    toggleLabel.innerText = browser.i18n.getMessage("yt_haven_toggle_label");
    toggleContainer.appendChild(toggleLabel);
    actionContainer.appendChild(toggleContainer);
    const menuElem = createMenuComponent();
    actionContainer.appendChild(menuElem);
    const infoElem = document.createElement("div");
    infoElem.innerText = browser.i18n.getMessage("yt_haven_info_box_description");
    infoElem.insertBefore(logoElem, infoElem.firstChild);
    infoBoxElem.appendChild(infoElem);
    infoBoxElem.appendChild(actionContainer);
    targetContainer.insertBefore(infoBoxElem, targetContainer.firstChild);
    void recordEvent(ytHavenInfoBoxShown);
}
export async function start(targetElement) {
    const [isExpEnabled, toggleState] = await Promise.all([
        isInHavenExperiment(),
        getToggleState(),
    ]);
    const targetInfoContainer = document.querySelector("#below");
    if (!isExpEnabled || !targetInfoContainer) {
        return;
    }
    const onToggle = async (newState) => {
        await browser.runtime.sendMessage({
            type: ytHavenToggleStateUpdate,
            newState,
        });
        if (newState) {
            startPause();
            void addEmbedVideoOnTop(targetElement);
        }
        else {
            stopPause();
            removeEmbedPlayer();
        }
    };
    addInfoBox(targetInfoContainer, Boolean(toggleState), onToggle);
    if (toggleState) {
        void addEmbedVideoOnTop(targetElement);
    }
    else {
        stopPause();
        removeEmbedPlayer();
    }
}
export const removeEmbedPlayer = () => {
    var _a;
    const playerElem = getIframePlayer();
    (_a = playerElem === null || playerElem === void 0 ? void 0 : playerElem.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(playerElem);
};
export const removeInfoBox = () => {
    var _a;
    const infoBoxElem = document.getElementById(infoBoxId);
    (_a = infoBoxElem === null || infoBoxElem === void 0 ? void 0 : infoBoxElem.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(infoBoxElem);
};
